import styled from 'styled-components';

import { OnboardingTitle } from '@/pages/Onboarding/components/Title';

export const MainImageStyles = styled.section`
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
`;

export const MainImageContentStyles = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1000 / 1440;
  background: url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/paywall/roleplay/paywall.png)
    no-repeat center center;
  background-size: contain;
  padding-top: 20px;
`;

export const MainImageTextContainerStyles = styled.div`
  position: absolute;
  text-align: center;
  bottom: 33%;
  left: 0;
  right: 0;
  z-index: 1;

  @media (max-width: 480px) {
    bottom: 27%;
  }

  @media (max-width: 375px) {
    bottom: 23%;
  }
`;

export const MainImageTitleStyles = styled(OnboardingTitle)`
  font-weight: 700;
`;
